import { Theme } from '@mui/material/styles'

const muiIconButton = (theme: Theme) => {
  return {
    variants: [
      {
        props: { color: 'primary' },
        style: {
          background: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          borderRadius: 4,
          '&:hover': {
            background: theme.palette.primary.dark
          },
          '&:disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
            color: theme.colors.disabled
          }
        }
      },
      {
        props: { color: 'secondary' },
        style: {
          background: theme.palette.secondary.main,
          color: theme.palette.secondary.contrastText,
          borderRadius: 4,
          '&:hover': {
            background: theme.palette.secondary.dark
          },
          '&:disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
            color: theme.colors.disabled
          }
        }
      },
      {
        props: { size: 'large' },
        style: {
          borderRadius: 10,
          height: '2.625rem',
          width: '2.625rem',
          '& svg': {
            height: '1.25rem',
            width: '1.25rem'
          }
        }
      },
      {
        props: { size: 'medium' },
        style: {
          borderRadius: 9,
          height: '2.25rem',
          width: '2.25rem',
          '& svg': {
            height: '1.125rem',
            width: '1.125rem'
          }
        }
      },
      {
        props: { size: 'small' },
        style: {
          borderRadius: 8,
          height: '2rem',
          width: '2rem',
          '& svg': {
            height: '1.25rem',
            width: '1.25rem'
          }
        }
      },
      {
        props: { size: 'smallest' },
        style: {
          borderRadius: 7,
          height: '1.75rem',
          width: '1.75rem',
          '& svg': {
            height: '0.875rem',
            width: '0.875rem'
          }
        }
      }
    ]
  }
}

export default muiIconButton
